import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

function ScrollToTop({ history }) {
  useEffect(() => {
    const unlisten = history?.listen(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });
    return () => {
      if (history) unlisten();
    };
  }, []);

  return (null);
}

ScrollToTop.propTypes = {
  history: PropTypes.objectOf(PropTypes.any),
};

ScrollToTop.defaultProps = {
  history: null,
};

export default withRouter(ScrollToTop);
